  console.log("GuitarCalcScript loaded successfully.");

    (function() {
        // Function to calculate density
        function calculate_density(mass, height, length, width) {
            return mass / (height * length * width);
        }

        // Function to calculate Young's Modulus along a direction
        function calculate_youngs_modulus(density, length, freq, height) {
            return 0.94146 * (density * Math.pow(length, 4) * Math.pow(freq, 2)) / Math.pow(height, 2);
        }

        // Function to calculate Shear Modulus
        function calculate_shear_modulus(density, length, width, freq, height) {
            return 1.21585 * density * Math.pow(length, 2) * Math.pow(width, 2) * Math.pow(freq, 2) / Math.pow(height, 2);
        }


        // Main function to perform the magic calculation
  function magic_function(length, lower_bout, mass, panel_height, panel_length, panel_width, long_freq, cross_freq, twist_freq, target_freq) {
      try {
          // Step 1: Calculate density
          var density = calculate_density(mass, panel_height, panel_length, panel_width);
          console.log("Density (rho): " + density);
  
          var f = target_freq;
          var a = length;
          var b = lower_bout;
          var p = density;
  
          // Step 2: Calculate Young's Moduli along the grain
          var EL = calculate_youngs_modulus(density, panel_length, long_freq, panel_height);
          var EC = calculate_youngs_modulus(density, panel_width, cross_freq, panel_height);
          var GLC = calculate_shear_modulus(density, panel_length, panel_width, twist_freq, panel_height);
  
          console.log("Young's Modulus along the grain (EL): " + EL);
          console.log("Young's Modulus across the grain (EC): " + EC);
          console.log("Shear Modulus (GLC): " + GLC);
  
          // Step 3: Calculate the target thickness (h) using the given formula
          var numerator = 0.95977 * f * Math.pow(a, 2) * Math.sqrt(p);
          var denominator = Math.sqrt(EL + Math.pow(a / b, 4) * EC + Math.pow(a / b, 2) * (0.02857 * EL + 1.12 * GLC));
  
          var h = numerator / denominator;

          var projected_mass = density * h * panel_length * panel_width;
        
          console.log("Numerator: " + numerator);
          console.log("Denominator: " + denominator);
          console.log("Calculated thickness (h): " + h);
          console.log("Projected Mass: " + projected_mass);
        
          if (isNaN(h) || !isFinite(h)) {
              return null;
          }
  
          // Return all values
          return { h: h, p, EL: EL, EC: EC, GLC: GLC, projected_mass: projected_mass };
      } catch (error) {
          console.error("Error in magic_function: ", error);
          return null;
      }
  }
// Function to handle the thickness calculation
function calculateThickness() {
    try {
        var length = parseFloat(document.getElementById("body_length").value);
        var lower_bout = parseFloat(document.getElementById("lower_bout").value);
        var mass = parseFloat(document.getElementById("mass").value);
        var panel_height = parseFloat(document.getElementById("panel_height").value);
        var panel_length = parseFloat(document.getElementById("panel_length").value);
        var panel_width = parseFloat(document.getElementById("panel_width").value);
        var long_freq = parseFloat(document.getElementById("long_freq").value);
        var cross_freq = parseFloat(document.getElementById("cross_freq").value);
        var twist_freq = parseFloat(document.getElementById("twist_freq").value);
        var target_freq_input = document.getElementById("target_freq").value;
        var target_freq = target_freq_input ? parseFloat(target_freq_input) : 75.0;

        // Validate inputs
        if (
            isNaN(length) || isNaN(lower_bout) || isNaN(mass) ||
            isNaN(panel_height) || isNaN(panel_length) || isNaN(panel_width) ||
            isNaN(long_freq) || isNaN(cross_freq) || isNaN(twist_freq) ||
            isNaN(target_freq)
        ) {
            alert("Please enter valid numerical values.");
            return;
        }

        if (
            length <= 0 || lower_bout <= 0 || mass <= 0 ||
            panel_height <= 0 || panel_length <= 0 || panel_width <= 0 ||
            long_freq <= 0 || cross_freq <= 0 || twist_freq <= 0 ||
            target_freq <= 0
        ) {
            alert("All input values must be positive numbers.");
            return;
        }

        // Execute the main calculation function
        var result = magic_function(
            length, lower_bout, mass, panel_height, panel_length, panel_width,
            long_freq, cross_freq, twist_freq, target_freq
        );

        // Display the results
        if (result !== null && !isNaN(result.h)) {
            var thickness_mm = result.h * 1000;
            document.getElementById("result").innerHTML =
                "Target Thickness (h): " + thickness_mm.toFixed(2) + " mm" + "<br>" +
                "Projected Mass (m): " + ((result.projected_mass)*1000).toFixed(1) + " g" + "<br>" +              
                "Density (p): " + result.p.toFixed(2) + " kg/m^3" + "<br>" +
                "Young's Modulus along the grain (EL): " + ((result.EL / 1e9).toFixed(2)) + " GPa" + "<br>" +
                "Young's Modulus across the grain (EC): " + ((result.EC / 1e9).toFixed(2)) + " GPa" + "<br>" +
                "Shear Modulus (GLC): " + ((result.GLC / 1e9).toFixed(2)) + " GPa";

            // Clear any previous results
            //document.getElementById("result").innerHTML = "";

            // Create a table
            var table = document.createElement("table");
            table.setAttribute("border", "1");
            table.setAttribute("style", "width: 100%; border-collapse: collapse; text-align: left;");

            // Add table header
            var headerRow = document.createElement("tr");
            headerRow.innerHTML = `
                <th >L</th>
                <th>W</th>
                <th>H</th>
                <th>M</th>
                <th>P</th>
                <th>FL</th>
                <th>FC</th>
                <th>FT</th>
                <th>EL</th>
                <th>EC</th>
                <th>EL/EC</th>
                <th>GLC</th>
                <th>New H</th>
                <th>New M</th>
            `;
            table.appendChild(headerRow);

            // Add a row for calculated values
            var row = document.createElement("tr");
            row.innerHTML = `
                <td>${panel_length.toFixed(4)}</td>
                <td>${panel_width.toFixed(4)}</td>
                <td>${panel_height.toFixed(4)}</td>
                <td>${mass.toFixed(4)}</td>
                <td>${result.p.toFixed(3)}</td>
                <td>${long_freq.toFixed(2)}</td>
                <td>${cross_freq.toFixed(2)}</td>
                <td>${twist_freq.toFixed(2)}</td>
                <td>${(result.EL / 1e9).toFixed(2)}</td>
                <td>${(result.EC / 1e9).toFixed(2)}</td>
                <td>${(result.EL / result.EC).toFixed(2)}</td>
                <td>${(result.GLC / 1e9).toFixed(2)}</td>
                <td>${thickness_mm.toFixed(2)}</td>
                <td>${((result.projected_mass)).toFixed(4)}</td>
            `;
            table.appendChild(row);

            // Append the table to the result container
            document.getElementById("result").appendChild(table);
        } else {
            alert("Invalid calculation. Please check input values.");
        }
    } catch (error) {
        console.error("Error in calculateThickness: ", error);
        alert("An error occurred: " + error.message);
    }
}

        // Attach calculateThickness to global window for direct use
        window.calculateThickness = calculateThickness;
    }

)();
